import i18n from 'i18next';
import { isPayAtTablePlatform } from '../api/app';

const { UI } = Mobi2Go;

const PAY_AT_TABLE_ERROR_CODE = 'PayAtTableUnavailable';
const PAY_AT_TABLE_ORDER_UPDATE_CODE = 'PayAtTableOrderUpdate';

const PAY_AT_TABLE_ERROR_MESSAGE_CODE = '_pay_at_table';
const PAY_AT_TABLE_ORDER_UPDATE_MESSAGE_CODE = '_pay_at_table_order_update';

export { PAY_AT_TABLE_ERROR_CODE, PAY_AT_TABLE_ORDER_UPDATE_CODE };

/**-----------------------------------------------------------------------------
 * Errors to show to the customer when there are problems connecting to the
 * Mobi2Go Web API
 */
Mobi2Go.bind('app', 'serverRequestError', function(
    xhr,
    message,
    endpoint,
    error_was_handled
) {
    if (error_was_handled) {
        return;
    }

    let error_code = '';

    if (
        xhr.responseJSON &&
        xhr.responseJSON.error === PAY_AT_TABLE_ORDER_UPDATE_CODE
    ) {
        error_code = PAY_AT_TABLE_ORDER_UPDATE_MESSAGE_CODE;
    } else if (isPayAtTablePlatform()) {
        error_code = PAY_AT_TABLE_ERROR_MESSAGE_CODE;
    }

    const status = xhr.status || 0;

    let error_title;
    let error_message;

    // Custom error
    if (
        xhr.responseJSON &&
        xhr.responseJSON.error_custom &&
        xhr.responseJSON.error_custom.title &&
        xhr.responseJSON.error_custom.body
    ) {
        error_title = xhr.responseJSON.error_custom.title;
        error_message = xhr.responseJSON.error_custom.body;
    }
    else {
        error_title = i18n.t('server-errors:server_error_title');
        error_message = i18n.t(`server-errors:server_error_body${error_code}`);

        switch (status) {
            // Server error
            case 500:
                error_title += ' - 500';
                break;

            // Unauthorised
            case 401:
                error_title += ' - 401';
                break;

            // Bad request
            case 400:
                error_title += ' - 400';
                break;

            // Not found
            case 404:
                error_title += ' - 404';
                break;

            // Teapot
            case 418:
                error_title += ' - 418';
                break;

            // Timeout
            case 0:
                handleTimeoutErrorAlert();
                return;

            default:
        }
    }

    Mobi2Go.UI.centeredAlert({
        title: error_title,
        body: error_message,
        temp: true,
        temp_duration: 15000,
    });
});

let error_count = 0;
function handleTimeoutErrorAlert() {
    error_count++;

    setTimeout(function() {
        error_count--;
    }, 25000);

    if (error_count > 3) {
        if (Mobi2Go.UI.full_screen_alert) {
            Mobi2Go.UI.full_screen_alert.show({
                icon: 'exclamation-mark',
                text: i18n.t('server-errors:mobile_timeout_error_text'),
                subtext: i18n.t('server-errors:mobile_timeout_error_subtext'),
                primary_button: i18n.t(
                    'server-errors:mobile_timeout_error_primary_button'
                ),
            });
        } else {
            Mobi2Go.UI.centeredAlert({
                title: i18n.t('server-errors:timeout_error_title'),
                body: i18n.t('server-errors:timeout_error_body'),
                temp: true,
                temp_duration: 10000,
            });
        }
    }
}
